import { render, staticRenderFns } from "./ezam_jintonn_check.vue?vue&type=template&id=07b89dbc&scoped=true"
import script from "./ezam_jintonn_check.vue?vue&type=script&lang=js"
export * from "./ezam_jintonn_check.vue?vue&type=script&lang=js"
import style0 from "./ezam_jintonn_check.vue?vue&type=style&index=0&id=07b89dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b89dbc",
  null
  
)

export default component.exports